namespace advisorop.components.common {

    class SelectCuRepfeeGroupController {
        onRepfeeGroupSelected: any;
        selectedRepfeeGroup: domains.IRepFeeGroup;
        clearAfterSelect: string = "true";
        repGroupFeeOptions: domains.RepGroupFeeOptions;

        static $inject = ["repGroupApi"];
        constructor(private repGroupApi: services.RepGroupApi) {
        }
        
        search(searchTerm: string): ng.IPromise<{}> {
            return this.repGroupApi.search(searchTerm, this.repGroupFeeOptions)
                .then(response => { return response.data; },
                      err => { return []; });
        };

        onSelect(item, model, label, event): void {

            var repfeeGroup: domains.IRepFeeGroup = {};
            angular.copy(this.selectedRepfeeGroup, repfeeGroup);
            this.onRepfeeGroupSelected({ repfeeGroup: repfeeGroup });    

            //clear only if clear property is set
            if (this.clearAfterSelect === "true")
                this.resetSearch();
            
        };
        
        resetSearch(): void {
            console.log("Reset repfee group", this.selectedRepfeeGroup);
            this.selectedRepfeeGroup = { name: "", repNumber: ""};
        };  

        $onInit(): void {
        };

        $routerOnActivate(next, previous) {
        };      
    }



    class SelectCuRepfeeGroup implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onRepfeeGroupSelected: "&",
                selectedRepfeeGroup: "=",                
                clearAfterSelect: "@",
                repGroupFeeOptions: "<"
            };
            this.controller = SelectCuRepfeeGroupController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/select-cu-repfee-group.html';
        }
    }
    angular.module(Constants.APP).component("selectCuRepfeeGroup", new SelectCuRepfeeGroup());


}